import useGetApi from 'src/api/useGetApi';
import { FamousShipmentType } from './FamousShipmentTypes';

interface PageInfo {
  hasNextPage: boolean;
  hasPreviousPage: boolean;
  totalCount: number;
  totalPages: number;
}

export enum OrderFetchStatus {
  pending = 'pending',
  fetching = 'fetching',
  success = 'success',
  failed = 'failed',
}

export interface FamousShipmentDTO {
  id: string;
  famousShipmentId: string;
  shipmentDetails: FamousShipmentType | null;
  shipmentFetchStatus: OrderFetchStatus;
  shipmentFetchError: Record<string, unknown> | null;
  edi856SentAt: Date | null;
  edi856Status: string | null;
  edi856StatusLastFetchedAt: Date | null;
  createdAt: Date;
  updatedAt: Date;
}

interface QueryParams {
  page?: number;
  pageSize?: number;
}

type ApiResponse = {
  edges: FamousShipmentDTO[];
  pageInfo: PageInfo;
};

const useFamousShipments = (params?: QueryParams, enabled?: boolean) => {
  return useGetApi<ApiResponse>({
    endpoint: 'famous/shipments',
    queryParameters: params,
    options: {
      enabled,
    },
  });
};

export default useFamousShipments;
